import { PAYMENT_DIRECTION_ID, PAYOUT_DIRECTION_ID } from 'constants/directions';
import { OrderAdjustmentsTypes } from 'constants/orderAdjustmentTypes';
import { OrderStatuses } from 'constants/orderStatuses';

import { TranslationKey } from 'providers/i18n/types';

export type AdjustmentConfig = {
  type: OrderAdjustmentsTypes;
  allowedStatuses: OrderStatuses[];
  allowedDirections: string[];
  tooltip: TranslationKey;
};

const ALL_DIRECTION_IDS: string[] = [PAYMENT_DIRECTION_ID, PAYOUT_DIRECTION_ID];

export const ORDER_AMOUNT_ADJUSTMENT_CONFIG: AdjustmentConfig = {
  type: OrderAdjustmentsTypes.OrderAmount,
  allowedStatuses: [OrderStatuses.Success],
  allowedDirections: ALL_DIRECTION_IDS,
  tooltip: 'app.orderAdjustments.allowedStatusSuccess',
};

export const ADJUSTMENT_CONFIGS: AdjustmentConfig[] = [
  ORDER_AMOUNT_ADJUSTMENT_CONFIG,
  {
    type: OrderAdjustmentsTypes.StatusToSuccess,
    allowedStatuses: [OrderStatuses.Failure, OrderStatuses.Expired, OrderStatuses.Pending],
    allowedDirections: ALL_DIRECTION_IDS,
    tooltip: 'app.orderAdjustments.allowedStatusPendingFailedExpired',
  },
  {
    type: OrderAdjustmentsTypes.StatusToRefund,
    allowedStatuses: [OrderStatuses.Success],
    allowedDirections: [PAYMENT_DIRECTION_ID],
    tooltip: 'app.orderAdjustments.allowedStatusSuccess',
  },
  {
    type: OrderAdjustmentsTypes.StatusToChargeback,
    allowedStatuses: [OrderStatuses.Success],
    allowedDirections: [PAYMENT_DIRECTION_ID],
    tooltip: 'app.orderAdjustments.allowedStatusSuccess',
  },
  {
    type: OrderAdjustmentsTypes.StatusToFailure,
    allowedStatuses: [OrderStatuses.Success, OrderStatuses.Pending, OrderStatuses.Prepared],
    allowedDirections: ALL_DIRECTION_IDS,
    tooltip: 'app.orderAdjustments.allowedStatusPreparedSuccessPending',
  },
  {
    type: OrderAdjustmentsTypes.StatusToCanceled,
    allowedStatuses: [OrderStatuses.Created],
    allowedDirections: ALL_DIRECTION_IDS,
    tooltip: 'app.orderAdjustments.allowedStatusCreated',
  },
];
